import React, { PropsWithChildren } from 'react';
import { MediaPlayerError } from '@yi/core';

import { nr, isMediaId } from '~/common';

import { MediaPlayerBase } from './MediaPlayerBase';
import { MediaPlayerProvider } from './MediaPlayerProvider';
import { ReportPlaybackError } from './ReportPlaybackError';

export const BasicPlayer: React.FC<PropsWithChildren<{ mediaId: string }>> = ({
  children,
  mediaId,
}) => {
  if (!isMediaId(mediaId)) {
    nr.noticeError(new MediaPlayerError('invalid media id'), { mediaId });
    return null;
  }

  return (
    <MediaPlayerProvider mediaId={mediaId}>
      <MediaPlayerBase>{children}</MediaPlayerBase>
      <ReportPlaybackError mediaId={mediaId} />
    </MediaPlayerProvider>
  );
};
